import React from 'react';

interface LeaderBoardBarIconProps {
  height?: string;
}

const LeaderBoardBarIcon: React.FC<LeaderBoardBarIconProps> = props => {
  const { height = '250' } = props;
  return (
    <svg
      width={7}
      height={height}
      viewBox="0 0 7 250"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 0.999994C1 0.44771 1.44772 0 2 0H5C5.55228 0 6 0.447715 6 1V249H1V0.999994Z"
        fill="url(#paint0_linear_0_1)"
      />
      <line x1={6.5} y1={150.5} x2={0.5} y2={150.5} stroke="#97A1AC" strokeLinecap="round" />
      <line x1={6.5} y1={100.5} x2={0.5} y2={100.5} stroke="#97A1AC" strokeLinecap="round" />
      <line x1={6.5} y1={50.5} x2={0.5} y2={50.5} stroke="#97A1AC" strokeLinecap="round" />
      <line x1={6.5} y1={200.5} x2={0.5} y2={200.5} stroke="#97A1AC" strokeLinecap="round" />
      <line x1={6.5} y1={249.5} x2={0.5} y2={249.5} stroke="#97A1AC" strokeLinecap="round" />
      <defs>
        <linearGradient
          id="paint0_linear_0_1"
          x1={3.5}
          y1={0}
          x2={3.5}
          y2={249}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.0729167} stopColor="#B0F287" />
          <stop offset={0.302112} stopColor="#DFF176" />
          <stop offset={0.505208} stopColor="#FFF38A" />
          <stop offset={0.703125} stopColor="#FEC786" />
          <stop offset={1} stopColor="#FFA4A4" />
        </linearGradient>
      </defs>
    </svg>
  );
};
export default LeaderBoardBarIcon;
